import { SVGProps } from "react";

export default function OpenQuoteIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 13, width = 12, stroke = "#292D32", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M1 6.67188H3.89999C4.66499 6.67188 5.19 7.25188 5.19 7.96188V9.5719C5.19 10.2819 4.66499 10.8619 3.89999 10.8619H2.29001C1.58001 10.8619 1 10.2819 1 9.5719V6.67188"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 6.6756C1 3.6506 1.56501 3.15062 3.26501 2.14062"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.8125 6.67188H9.71249C10.4775 6.67188 11.0025 7.25188 11.0025 7.96188V9.5719C11.0025 10.2819 10.4775 10.8619 9.71249 10.8619H8.10251C7.39251 10.8619 6.8125 10.2819 6.8125 9.5719V6.67188"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.8125 6.6756C6.8125 3.6506 7.37748 3.15062 9.07748 2.14062"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
